import { atsApiQuery } from '..';

export const emailTemplatesSettingsApi = atsApiQuery.injectEndpoints({
  endpoints: (builder) => {
    return {
      getEmailTemplatesSettingsList: builder.query({
        providesTags: ['GetEmailTemplatesSettingsList'],
        transformResponse: (response) => response,
        query: ({ filters, params }) => {
          return {
            method: 'get',
            url: `/ats_comm_templates`,
            params,
          };
        },
        staleTime: 0,
      }),

      getTemplateById: builder.query({
        providesTags: ['GetTemplateById'],
        transformResponse: (response) => response?.data,
        query: ({ templateId }) => {
          return {
            method: 'get',
            url: `/ats_comm_templates/${templateId}`,
          };
        },
        staleTime: 0,
      }),

      getTemplatesCategories: builder.query({
        providesTags: ['GetTemplatesCategories'],
        transformResponse: (response) => response?.data,
        query: () => {
          return {
            method: 'get',
            url: `/ats_comm_templates/categories`,
          };
        },
      }),

      getTemplatesVariables: builder.query({
        providesTags: ['GetTemplatesVariables'],
        transformResponse: (response) => response?.data,
        query: ({ params }) => {
          params = { ...params, items: 200 };
          return {
            method: 'get',
            url: `/ats_comm_templates/variables`,
            params,
          };
        },
      }),

      getTemplatesUsers: builder.query({
        transformResponse: (response) => response?.data,
        query: () => {
          return {
            method: 'get',
            url: `/ats_comm_templates/users`,
          };
        },
      }),

      getPlaceholderPreview: builder.query({
        transformResponse: (response) => response?.data,
        query: ({ payload = {} }) => {
          return {
            method: 'post',
            url: `/ats_comm_templates/preview`,
            data: payload,
          };
        },
      }),

      createTemplate: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ id, payload }) => {
          return {
            method: 'post',
            url: `/ats_comm_templates/`,
            data: payload,
          };
        },
        invalidatesTags: (result) => {
          if (result) {
            return [{ type: 'GetEmailTemplatesSettingsList' }];
          }
          return [];
        },
      }),

      updateTemplateById: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ templateId, payload }) => {
          return {
            method: 'put',
            url: `/ats_comm_templates/${templateId}`,
            data: payload,
          };
        },
        invalidatesTags: (result) => {
          if (result) {
            return [{ type: 'GetEmailTemplatesSettingsList' }];
          }
          return [];
        },
      }),

      cloneEmailTemplate: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ id, payload }) => {
          return {
            method: 'post',
            url: `/ats_comm_templates/${id}/clone`,
            data: payload,
          };
        },
        invalidatesTags: (result) => {
          if (result) {
            return [{ type: 'GetEmailTemplatesSettingsList' }];
          }
          return [];
        },
      }),
      archiveEmailTemplate: builder.mutation({
        transformResponse: (response) => response,
        query: ({ id }) => {
          return {
            method: 'put',
            url: `/ats_comm_templates/${id}/archive`,
          };
        },
        invalidatesTags: () => {
          return [{ type: 'GetEmailTemplatesSettingsList' }];
        },
      }),
      previewTemplate: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ payload }) => {
          return {
            method: 'post',
            url: `/ats_comm_templates/send_preview_email`,
            data: { ...payload },
          };
        },
      }),
    };
  },
  overrideExisting: true,
});

export const {
  useLazyGetEmailTemplatesSettingsListQuery,
  useLazyGetTemplateByIdQuery,
  useUpdateTemplateByIdMutation,
  useGetTemplatesCategoriesQuery,
  useCloneEmailTemplateMutation,
  useArchiveEmailTemplateMutation,
  usePreviewTemplateMutation,
  useCreateTemplateMutation,
  useLazyGetTemplatesVariablesQuery,
  useGetTemplatesVariablesQuery,
  useGetTemplatesUsersQuery,
  useLazyGetPlaceholderPreviewQuery,
} = emailTemplatesSettingsApi;
